module.exports = __webpack_public_path__ + "img/exclamation_blue.a4a4d506.svg";